const ROLE_LABELS: Record<string, string> = {
  ROLE_ANALYST: 'Analyst',
  ROLE_ADMIN: 'Admin',
  ROLE_CLIENT_ANALYST: 'Client Analyst',
  ROLE_CLIENT_USER: 'Client User',
  ROLE_CLIENT_SERVICE: 'Service User',
};

export const formatUserRole = (role: string): string => {
  if (ROLE_LABELS[role]) {
    return ROLE_LABELS[role];
  }

  return role
    .replace(/^ROLE_/, '')
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};
